import { createFileRoute, redirect } from '@tanstack/react-router'
import Dashboard from '@/components/dashboard'
import NotFound from '@/components/not-found'

export const Route = createFileRoute('/admin')({
  notFoundComponent: () => <NotFound />,
  component: RouteComponent,
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  staticData: {
    breadcrumb: 'Admin',
  },
})

function RouteComponent() {
  return <Dashboard />
}
